class Downloads {
  constructor() {
    if (document.querySelectorAll('.download-btn')) {
      this.downloadBtnEventHandler();
    }
  }

  downloadBtnEventHandler() {
    let dlBtn = document.querySelectorAll('.download-btn');
    dlBtn.forEach(function (button, index) {
      button.addEventListener('click', function () {
        this.classList.add('clicked');
        setTimeout(() => {
          this.classList.remove('clicked');
        }, 5000);
      })
    })
  }
}

new Downloads();
